export class Settings {
  env = window['env']['env'];
  sentryDsn = window['env']['sentryDsn'];
  intercomAppId = window['env']['intercomAppId'];
  heapId = window['env']['heapId'];
  minimumContactsPerTreatmentPerBatch = window['env']['minimumContactsPerTreatmentPerBatch'];
  subjectLineApi = window['env']['subjectLineApi'];
}
